/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 4.75h3.325c.3475 1.7117 1.8608 3 3.675 3h6c1.8142 0 3.3275-1.2883 3.675-3H18c1.2426 0 2.25 1.0074 2.25 2.25v2c0 1.2426-1.0074 2.25-2.25 2.25h-.325c-.3475-1.7117-1.8608-3-3.675-3H8c-1.8142 0-3.3275 1.2883-3.675 3H4C1.929 11.25.25 12.9289.25 15v2c0 2.0711 1.679 3.75 3.75 3.75h.325c.3475 1.7117 1.8608 3 3.675 3h6c2.0711 0 3.75-1.6789 3.75-3.75s-1.6789-3.75-3.75-3.75H8c-1.8142 0-3.3275 1.2883-3.675 3H4c-1.2426 0-2.25-1.0074-2.25-2.25v-2c0-1.2426 1.0074-2.25 2.25-2.25h.325c.3475 1.7117 1.8608 3 3.675 3h6c1.8142 0 3.3275-1.2883 3.675-3H18c2.0711 0 3.75-1.6789 3.75-3.75V7c0-2.071-1.6789-3.75-3.75-3.75h-.325c-.3475-1.7117-1.8608-3-3.675-3H8c-1.8142 0-3.3275 1.2883-3.675 3H1a.75.75 0 0 0 0 1.5ZM8.25 4A.75.75 0 0 1 9 3.25h4a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 4ZM9 11.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H9ZM8.25 20a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M23.5303 18.5303a.75.75 0 0 0 0-1.0606.75.75 0 0 0-1.0606 0L20.5 19.4393l-.9697-.9696a.75.75 0 0 0-1.0606 0 .75.75 0 0 0 0 1.0606L20.5 21.5607l3.0303-3.0304Z"
    />
  </React.Fragment>,
  'MenuWorkflowsFilled'
);
